import { Stack, Text } from 'braid-design-system';
import type React from 'react';

import type { CreditCardBrandInput } from '../../usecases/CreditCard/creditcardTypes';

import IconAmex from './icons/IconAmex';
import IconMastercard from './icons/IconMastercard';
import IconVisa from './icons/IconVisa';

import * as styles from './BrandIcon.css';

const getIcon = (brand: CreditCardBrandInput) => {
  switch (brand) {
    case 'VISA':
      return <IconVisa />;
    case 'MASTER_CARD':
      return <IconMastercard />;
    case 'AMEX':
      return <IconAmex />;
    default:
      return <></>;
  }
};

const BrandIcon: React.FC<{
  active: boolean;
  brand: CreditCardBrandInput;
  hasSurcharge: boolean;
}> = ({ active, brand, hasSurcharge }) => (
  <div
    className={active || brand === 'UNKNOWN' ? undefined : styles.brandInactive}
  >
    <Stack space="xxsmall">
      {getIcon(brand)}
      {hasSurcharge ? (
        <Text size="xsmall" tone="secondary">
          Fees apply
        </Text>
      ) : (
        <Text />
      )}
    </Stack>
  </div>
);

export { BrandIcon };
